import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function ProductContents() {
  const contents = ['El Manual Digital "Controla la Ansiedad en 10 Minutos" (Formato PDF)', 'El Protocolo de Emergencia 4-2-8 para detener taquicardias al instante', 'La técnica de "Blindaje Nocturno" para volver a dormir tras un despertar con pánico', 'El Método de "Sacudida de Cortisol" para limpiar el estrés acumulado del día', 'Checklist de Micro-señales para frenar la ansiedad antes de que escale'];
  return <section className="w-full py-24 px-4 bg-brand-cream" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <span className="text-brand-purple font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-178">
            Lo que recibes
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-slate" data-id="element-179">
            Todo lo que incluye tu guía
          </h2>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-brand-creamDark" data-id="element-180">
          <ul className="space-y-6" data-id="element-181">
            {contents.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-182">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-183" />
                <span className="text-lg md:text-xl text-brand-navy leading-relaxed font-medium" data-id="element-184">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}